module.exports = "<figure> <img width=118px ng-src=assets/cenceo.logo.green.svg?v_1 alt=Cenceo> </figure> <div class=row> <h3 class=\"col-xs-12 page-header\">{{vm.titleText | translate}}</h3> </div> <ng-transclude></ng-transclude> <hr class=row> <div class=\"row support\"> <div class=\"col-xs-12 text-center\"> <h5><i class=\"fa fa-life-ring\" aria-hidden=true></i> {{'cenceo.login.need_help' | translate}}</h5> <p ng-bind-html=\"'cenceo.login.contact_us' | translate: { email: '<a href=\\'mailto:support@cenceo.se\\'>support@cenceo.se</a>' }\"></p> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-login/cn-login.html
 ** module id = 125
 ** module chunks = 0
 **/